import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const pageTitle = 'Cotiz� tu seguro de Caucion-Alquiler | Sancor Seguros';
const contentMetaData = 'Alquil� tranquilo y sin complicaciones con nuestro Seguro de Cauci�n para Alquiler.'

const routes: Array<RouteConfig> = [
    // Ruta comod�n debe ir al final siempre
    {
        path: "/caucion-alquiler/:subpath*",
        name: "tabOne",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
];

export default routes;